import { AddToCartItem, ProductBuilderMachineContext } from '../types';

type RollerblindAddonProducts = (
  context: ProductBuilderMachineContext,
  upi: string,
  roomName: string,
  parentProductTitle: string,
) => AddToCartItem[];

export const getVenetianAddonProducts: RollerblindAddonProducts = (
  {
    measureInsurance: measureInsuranceAddonProducts,
    venetianValance: venetianValanceAddonProducts,
    quantity,
    custom: { measureInsurance, venetianValance },
  },
  upi,
  roomName,
  parentProductTitle,
) => {
  return measureInsuranceAddonProducts
    .concat(venetianValanceAddonProducts)
    .filter(({ first_available_variant: { id }, variants }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isVenetianValance = variants.find(
        variant => variant.id === venetianValance,
      );
      return isMeasureInsurance || isVenetianValance;
    })
    .map(({ first_available_variant: { id }, variants }) => {
      const isMeasureInsurance = id === measureInsurance;
      const isVenetianValance = variants.find(
        variant => variant.id === venetianValance,
      );

      const addonId = isVenetianValance ? venetianValance : id;

      return {
        quantity: isMeasureInsurance ? 1 : quantity,
        id: addonId,
        properties: !isMeasureInsurance
          ? {
              _upi: upi,
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            }
          : {
              _upi: '',
              'Product for': `${parentProductTitle} - Room: ${roomName}`,
            },
      };
    });
};
